export default __webpack_public_path__ + "static/media/ai.13c955de.png";